import { Api, ApiResponse } from './api';

export class MetaApi {
    constructor(public readonly url: string, private readonly api: typeof Api) {}

    async languages(): Promise<ApiResponse<string[]>> {
        return this.api.api_get<string[]>(`${this.url}/api/languages`);
    }

    async resources(): Promise<ApiResponse<Record<string, string|null>>> {
        return this.api.api_get<Record<string, string|null>>(`${this.url}/api/resources`);
    }
}
